import {IClientUpdatePayload} from "../api/for_you_client";
import {IForYouModal} from "../types/IForYouModal";
import {getPostData} from "./get_post_data";
import {getUpdateData} from "./get_update_data";

export const getExistingUserPostData = (modalState: IForYouModal): IClientUpdatePayload => {
    const postData = getPostData(modalState);
    const updateData = getUpdateData(modalState);

    return {
        ...postData,
        ...updateData
    };
};
import {IClientUpdatePayload} from "../api/for_you_client";
import {IForYouModal} from "../types/IForYouModal";
import {getPostData} from "./get_post_data";
import {getUpdateData} from "./get_update_data";

export const getExistingUserPostData = (modalState: IForYouModal): IClientUpdatePayload => {
    const postData = getPostData(modalState);
    const updateData = getUpdateData(modalState);

    return {
        ...postData,
        ...updateData
    };
};
